module.exports={
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [-154,
              83]
      },
      "properties": {
        "name": "null island"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [-154,
              -70]
      },
      "properties": {
        "name": "null island"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [180,
              -70]
      },
      "properties": {
        "name": "null island"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [180,
              83]
      },
      "properties": {
        "name": "null island"
      }
    }
  ]
}